import { APIHandler } from "utilities/apiHandler";

import {
    ActivationResponse,
    type IUserActivationRequest,
} from "commonComponents/entity/credentials/Credentials/Credentials.api.types";

import { LoginResponse, UserProfileResponse } from "entity/login/Login/Login.api.types";

import {
    Auth0ActivationResponse,
    type IFinalizeActivationRequest,
    type IUserActivationLinkRequest,
    type IUserActivationPageLoginRequest,
} from "./UserActivationPage.api.types";

export interface IUserActivationPageHandler {
    createNewUser: (request: IUserActivationRequest) => Promise<ActivationResponse>;
    linkExisting: (request: IUserActivationLinkRequest) => Promise<ActivationResponse>;
    login: (request: IUserActivationPageLoginRequest) => Promise<LoginResponse>;
    profile: (userId: number) => Promise<UserProfileResponse>;
    finalizeActivation: (request: IFinalizeActivationRequest) => Promise<Auth0ActivationResponse>;
}

export class UserActivationPageHandler implements IUserActivationPageHandler {
    async createNewUser(request: IUserActivationRequest): Promise<ActivationResponse> {
        return await APIHandler("/api/Users/CreateNewUser", {
            method: "POST",
            data: request,
            responseType: ActivationResponse,
        });
    }

    async linkExisting(request: IUserActivationLinkRequest): Promise<ActivationResponse> {
        return await APIHandler("/api/Users/LinkExisting", {
            method: "PUT",
            data: request,
            responseType: ActivationResponse,
        });
    }

    async login(request: IUserActivationPageLoginRequest): Promise<LoginResponse> {
        return await APIHandler("/api/Login/AjaxLogin", {
            method: "POST",
            data: request,
            responseType: LoginResponse,
        });
    }

    async profile(userId: number): Promise<UserProfileResponse> {
        return await APIHandler("/api/Users/Profile", {
            method: "GET",
            data: { userId },
            responseType: UserProfileResponse,
        });
    }

    async finalizeActivation(
        request: IFinalizeActivationRequest,
    ): Promise<Auth0ActivationResponse> {
        return await APIHandler("/api/Users/FinalizeActivation", {
            method: "POST",
            data: request,
            responseType: Auth0ActivationResponse,
        });
    }
}

export const defaultUserActivationHandler = new UserActivationPageHandler();
